import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}
import BaseCommand from './BaseCommand';
import { savePaymentMethodsCommands } from '../../redux/command/command.slice';
import { saveConfigs } from '../../redux/config/config.slice';
import { Component, ContextType, DropInPaymentsCommandNames, fireStatusUpdate, Namespace, SharedCommandNames, StatusTypes } from '@chegg/commerce-utils';
import { saveCartInfo } from '../../redux/cart/cart.slice';
export var AddCouponCommand = /*#__PURE__*/function (_BaseCommand) {
  function AddCouponCommand() {
    _classCallCheck(this, AddCouponCommand);
    return _callSuper(this, AddCouponCommand, arguments);
  }
  _inherits(AddCouponCommand, _BaseCommand);
  return _createClass(AddCouponCommand, [{
    key: "execute",
    value: function () {
      var _execute = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _this$input$data, couponCode, productType, checkoutFlowType, cartId, response, _ref, orderSummary, code, total, subtotal, currencyName;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this$input$data = this.input.data, couponCode = _this$input$data.couponCode, productType = _this$input$data.productType, checkoutFlowType = _this$input$data.checkoutFlowType, cartId = _this$input$data.cartId; // clear current state for coupon and try applying a new one
              this.dispatch(saveConfigs({
                coupon: {
                  addCouponStatus: '',
                  removeCouponStatus: '',
                  totalWithCurrencyFormat: ''
                }
              }));
              _context.next = 4;
              return this.client.couponApi.couponAction({
                productType: productType,
                checkoutFlowType: checkoutFlowType,
                coupon: {
                  code: couponCode,
                  command: 'ADD'
                },
                cartId: cartId
              });
            case 4:
              response = _context.sent;
              if (!this.hasErrors(response.errors)) {
                _context.next = 9;
                break;
              }
              this.callbackErrorsToHost(response.errors, DropInPaymentsCommandNames.ADD_COUPON);

              // update addCouponStatus prop to error in case of api response error
              this.dispatch(saveConfigs({
                coupon: {
                  addCouponStatus: StatusTypes.ERROR,
                  removeCouponStatus: '',
                  totalWithCurrencyFormat: ''
                }
              }));
              return _context.abrupt("return");
            case 9:
              _ref = response.data, orderSummary = _ref.orderSummary, code = _ref.coupon.code;
              fireStatusUpdate([{
                status: StatusTypes.SUCCESS,
                command: DropInPaymentsCommandNames.ADD_COUPON,
                payload: {
                  component: Component.COMMAND_MANAGER,
                  context: ContextType.DROP_IN_PAYMENTS,
                  data: {
                    orderSummary: orderSummary,
                    couponCode: code
                  }
                }
              }], Namespace.DROP_IN_PAYMENTS);

              // update addCouponStatus prop to success in case of api response error
              this.dispatch(saveConfigs({
                couponCode: couponCode,
                coupon: {
                  addCouponStatus: StatusTypes.SUCCESS,
                  removeCouponStatus: '',
                  totalWithCurrencyFormat: orderSummary.totalWithCurrencyFormat
                }
              }));
              this.dispatch(saveCartInfo({
                orderSummary: orderSummary
              }));
              total = orderSummary.total, subtotal = orderSummary.subtotal, currencyName = orderSummary.currencyName;
              this.dispatch(savePaymentMethodsCommands([{
                commandName: SharedCommandNames.UPDATE_PRICING,
                data: {
                  total: total,
                  subtotal: subtotal,
                  currency: currencyName
                }
              }]));
            case 15:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function execute() {
        return _execute.apply(this, arguments);
      }
      return execute;
    }()
  }]);
}(BaseCommand);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/dropin-payments/dist/esm/commandManager/commands/AddCouponCommand.js
// module id = 4691
// module chunks = 11